let popups = require( './modals' );

var online_events = ( function( $ ) {

	var youtube_timeout;
	var videos_marked_finished = [];

	var $session_popup;

	var session_update_timeouts = [];

	var _init = function() {
		if ( $( '#online-event-page' ).length > 0 ) {
			_initiate_slide_toggles();

			var $video_links      = $( '.event-video-link' );
			var $links            = $( '.go-to-section-link' );
			var $vimeo_iframes    = $( '.vimeo-player' );
			var $youtube_iframes  = $( '.youtube-player' );

			if ( $video_links.length > 0 ) {
				$video_links.on( 'click', _handle_change_video );
			}

			if ( $links.length > 0 ) {
				$links.on( 'click', _handle_go_to_link_click );
			}

			$vimeo_iframes.each( function( video_id, iframe ) {
				var video_id = $( iframe ).attr( 'id' ).replace( 'event-video-', '' );
				_initialise_vimeo( $( iframe ), video_id );
			} );

			$youtube_iframes.each( function( video_id, iframe ) {
				var video_id = $( iframe ).attr( 'id' ).replace( 'event-video-', '' );
				_initialise_youtube( $( iframe ), video_id );
			} );

			_initialise_sessions();
			_initialise_session_modal();

			_initiate_update_session_card_timeouts();
		}
	};

	// Videos

	var _initialise_youtube = function( $iframe, video_id ) {
		YT.ready( function() {
			var player = new YT.Player( $iframe.attr( 'id' ) );

			player.addEventListener( 'onStateChange', function( e ) {
				// This means video has ended
				if ( e.data === 0 ) {
					_on_video_end( video_id )
				}
				// Create a timeout to check if video is 10 seconds from over after the time it should take to get there
				if ( e.data === 1 ) {
					_create_new_youtube_timeout( player, video_id );
				}
			} );
		} );
	};

	var _create_new_youtube_timeout = function( player, video_id ) {
		if ( youtube_timeout ) {
			clearTimeout( youtube_timeout );
		}

		var duration     = player.getDuration();
		var current_time = player.getCurrentTime();
		var timeout      = ( duration - current_time - 10 ) * 1000;

		if ( timeout <= 0 ) {
			_on_video_end( video_id );
		} else {
			youtube_timeout = setTimeout( function() {
				if ( player.getCurrentTime() >= duration - 10 ) {
					_on_video_end( video_id );
				} // Otherwise create a new timer in case timing is off
				else {
					_create_new_youtube_timeout( player, video_id );
				}
			}, timeout );
		}
	};

	var _initialise_vimeo = function( $iframe, video_id ) {
		var player = new Vimeo.Player( $iframe );

		player.on( 'ended', video_id => _on_video_end( video_id ) );
		// Check if 10 seconds from over
		player.on( 'timeupdate', function( data ) {
			if ( data.duration - data.seconds < 10 ) {
				_on_video_end( video_id );
			}
		} );
	};

	var _on_video_end = function( video_id ) {
		if ( videos_marked_finished[ video_id ] ) {
			return;
		}

		var urlParams = new URLSearchParams( window.location.search );

		var data = {
			ticket: urlParams.get( 'ticket' ),
			video_id: video_id,
			action: 'crate_mark_video_watched',
			nonce: ScriptData.crate_mark_video_watched_nonce,
		};

		$.ajax( {
			type: 'POST',
			url: ScriptData.ajaxurl,
			data: data,
			success: _mark_video_watched_response,
		} );
	};

	var _mark_video_watched_response = function( res ) {
		if ( res.success ) {
			videos_marked_finished[ res.video_id ] = true;
		} else {
			console.log( 'Mark as complete failed: ', res );
		}
	};

	// Sidebar

	var _handle_go_to_link_click = function( e ) {
		e.preventDefault();

		var $link    = $( e.currentTarget );
		var $element = $( $link.attr( 'href' ) );

		$( 'html,body' ).animate( { scrollTop: $element.offset().top }, 'slow' );
	};

	var _handle_change_video = function( e ) {
		e.preventDefault();

		var $link            = $( e.currentTarget );
		var $current_link    = $( '.event-video-link.selected' );
		var video_id         = $link.attr( 'data-video-id' );
		var $current_video   = $( '.current-video' );
		var current_video_id = $current_video.attr( 'data-video-id' );

		if ( current_video_id === video_id ) {
			return;
		}

		var $new_video = $( '.video[data-video-id=' + video_id + ']' );

		if ( $new_video.length > 0 ) {
			$current_video.attr( 'hidden', true );
			$current_video.removeClass( 'current-video' );
			$current_link.removeClass( 'selected' );

			$new_video.attr( 'hidden', false );
			$new_video.addClass( 'current-video' );
			$link.addClass( 'selected' );
		}
	};

	var _initiate_slide_toggles = function( e ) {
		var $instructor_info_toggle = $( '#instructor-info-toggle' );
		var $instructor_info_icon   = $instructor_info_toggle.find( '.opened-indicator' );
		var $instructor_info        = $( '#responsive-instructor-info' );

		var $toggle_menu_button = $( '#responsive-menu-toggle' );
		var $toggle_menu_icon   = $toggle_menu_button.find( '.opened-indicator' );
		var $responsive_menu    = $( '#responsive-menu' );

		var $toggle_bio      = $( '.toggle-bio' );
		var $toggle_bio_icon = $toggle_bio.find( '.opened-indicator' );
		var $bio             = $( '.bio' );

		if ( $toggle_menu_button.length > 0 && $responsive_menu.length > 0 ) {

			$toggle_menu_button.on( 'click', function( e ) {
				$toggle_menu_icon.toggleClass( 'open' );
				$responsive_menu.slideToggle();
			} );
		}

		if ( $instructor_info_toggle.length > 0 && $instructor_info.length > 0 ) {

			$instructor_info_toggle.on( 'click', function( e ) {
				$instructor_info_icon.toggleClass( 'open' );
				$instructor_info.slideToggle();
			} );
		}

		if ( $toggle_bio.length > 0 && $bio.length > 0 ) {
			$toggle_bio.on( 'click', function( e ) {
				$toggle_bio_icon.toggleClass( 'open' );
				$bio.slideToggle();
			} );
		}
	};

	// Sessions

	var _initialise_sessions = function() {
		var $book_now_buttons = $( '.session-book-now' );
		var $cancel_button    = $( '.cancel-button' );

		if ( $book_now_buttons.length > 0 ) {
			$book_now_buttons.on( 'click', _handle_book_session );
		}

		if ( $cancel_button.length > 0 ) {
			$cancel_button.on( 'click', _handle_cancel_session );
		}
	};

	var _handle_book_session = function( e ) {
		e.preventDefault();

		var $button    = $( e.currentTarget );
		var session_id = $button.attr( 'data-session-index' );
		var urlParams  = new URLSearchParams( window.location.search );

		// Hide any errors
		var $error = $( '.online-session[data-session-index="' + session_id + '"] .error' );
		$error.attr( 'hidden', true );

		var data = {
			ticket: urlParams.get( 'ticket' ),
			session_id: session_id,
			action: 'crate_book_qna_session',
			nonce: ScriptData.crate_book_qna_session_nonce,
		};

		$.ajax( {
			type: 'POST',
			url: ScriptData.ajaxurl,
			data: data,
			success: _book_session_response,
		} );
	};

	var _book_session_response = function( res ) {
		var $session_section = $( '#live-qna-sessions' );

		if ( res.success ) {
			$session_section.replaceWith( res.sessions_html );

			_initialise_sessions();
			_reinitialise_session_modal();

			$session = $( '.online-session[data-session-index="' + res.session_id + '"]' );
			_initialise_update_session_card_timeout( $session );
		} else {
			var $session = $( '.online-session[data-session-index="' + res.session_id + '"]' );
			var $error   = $session.find( '.error' );

			$error.text( res.error );
			$error.attr( 'hidden', false );
			$error.css( 'text-align', 'left' );
		}
	};

	var _handle_cancel_session = function( e ) {
		e.preventDefault();

		var $button    = $( e.currentTarget );
		var session_id = $button.attr( 'data-session-index' );
		var urlParams  = new URLSearchParams( window.location.search );

		// Hide any errors
		var $error = $( '.online-session[data-session-index="' + session_id + '"] .error' );
		$error.attr( 'hidden', true );

		var data = {
			ticket: urlParams.get( 'ticket' ),
			session_id: session_id,
			action: 'crate_cancel_qna_session',
			nonce: ScriptData.crate_cancel_qna_session_nonce,
		};

		$.ajax( {
			type: 'POST',
			url: ScriptData.ajaxurl,
			data: data,
			success: _cancel_session_response,
		} );
	};

	var _cancel_session_response = function( res ) {
		var $session_section = $( '#live-qna-sessions' );

		if ( res.success ) {
			$session_section.replaceWith( res.sessions_html );

			_initialise_sessions();
			_reinitialise_session_modal();

			$session = $( '.online-session[data-session-index="' + res.session_id + '"]' );
			_initialise_update_session_card_timeout( $session );
		} else {
			var $session = $( '.online-session[data-session-index="' + res.session_id + '"]' );
			var $error   = $session.find( '.error' );

			$error.text( res.error );
			$error.attr( 'hidden', false );
			$error.css( 'text-align', 'center' );
		}
	};

	// Sessions modals

	var _initialise_session_modal = function() {
		$session_popup = $( '#online-session-modal' );

		$session_popup.find( '.cross-icon' ).on( 'click', function() {
			popups.close_modal( $session_popup );
		} );

		$session_popup.on( 'closed', _pause_modal_vimeo_videos );

		var $open_modal_buttons = $( '#live-qna-sessions' ).find( '.buttons' ).find( 'a[href="#online-session-modal"]' );

		if ( $open_modal_buttons.length > 0 ) {
			$open_modal_buttons.each( index => {
				var $button = $( $open_modal_buttons[ index ] );

				if ( !$button.hasClass( 'initialised' ) ) {
					$button.on( 'click', _on_open_session_modal );
					$button.addClass( 'initialised' );
				}
			} );
		}
	};

	var _reinitialise_session_modal = function() {
		popups.init();
		_initialise_session_modal();
	};

	var _on_open_session_modal = function( e ) {
		var $button    = $( this );
		var session_id = $button.attr( 'data-session-index' );

		// Only load session data if it's a different session from last
		if ( $session_popup.attr( 'data-current-session' ) === session_id ) {
			return;
		}

		$session_popup.find( '.title' ).text( '' );
		$session_popup.find( '.embed-content' ).html( '' );
		$session_popup.find( '.error' ).html( '' );
		$session_popup.attr( 'data-current-session', '' );

		var urlParams  = new URLSearchParams( window.location.search );

		var data = {
			session_id: session_id,
			ticket: urlParams.get( 'ticket' ),
			action: 'crate_get_modal_session_content',
			nonce: ScriptData.crate_get_modal_session_content_nonce,
		};

		$.ajax( {
			type: 'GET',
			url: ScriptData.ajaxurl,
			data: data,
			success: _get_session_modal_content_response,
		} );
	};

	var _get_session_modal_content_response = function( res ) {
		if ( res.success ) {
			var $title         = $session_popup.find( '.title' );
			var $embed_content = $session_popup.find( '.embed-content' );

			$title.text( res.title );
			$embed_content.html( res.embed );
			$session_popup.attr( 'data-current-session', res.session_id );
		} else {
			var error  = res.error || 'There was an issue in retrieving this session. Please reload your browser and try again.';
			var $error = $session_popup.find( '.error ' );

			$error.text( error );
		}
	};

	var _pause_modal_vimeo_videos = function() {
		var $iframes = $session_popup.find( 'iframe' );

		if ( $iframes.length > 0 ) {

			$iframes.each( index => {
				var $iframe = $( $iframes[ index ] );
				var player  = new Vimeo.Player( $iframe );

				if ( player ) {
					player.pause();
				}
			} );
		}
	};

	// Sessions automatic updates

	var _initiate_update_session_card_timeouts = function() {
		var $sessions = $( '.online-session' );

		if ( $sessions.length > 0 ) {
			$sessions.each( session_id => {
				var $session = $( $sessions[ session_id ] );

				_initialise_update_session_card_timeout( $session )
			} );
		}
	};

	var _initialise_update_session_card_timeout = function( $session ) {
		//TODO: closing too?

		var session_id          = $session.attr( 'data-session-index' );
		var next_update         = parseInt( $session.attr( 'data-session-open-time' ) );
		var unix_now            = Math.round( +new Date() / 1000 );
		var time_to_next_update = ( next_update - unix_now ) * 1000;

		// Beyond maximum size that setTimeout can handle
		if ( time_to_next_update > 2147483647 ) {
			return;
		}

		if ( session_id in session_update_timeouts ) {
			clearTimeout( session_update_timeouts[ session_id ] );
		}

		if ( time_to_next_update > 0 ) {
			session_update_timeouts[ session_id ] = setTimeout( () => _update_session_card( session_id ), time_to_next_update );
		}
	};

	var _update_session_card = function( session_id ) {
		var urlParams = new URLSearchParams( window.location.search );

		var data = {
			session_id: session_id,
			ticket: urlParams.get( 'ticket' ),
			action: 'crate_get_session_card',
			nonce: ScriptData.crate_get_session_card_nonce,
		};

		$.ajax( {
			type: 'GET',
			url: ScriptData.ajaxurl,
			data: data,
			success: _update_session_card_response,
		} );
	};

	var _update_session_card_response = function( res ) {
		if ( res.success ) {
			var $session = $( '.online-session[data-session-index="' + res.session_id + '"]' );
			$session.replaceWith( res.session_html );
			$session = $( '.online-session[data-session-index="' + res.session_id + '"]' );

			_initialise_sessions();
			_reinitialise_session_modal();
			_initialise_update_session_card_timeout( $session );
		} else {
			console.log( 'Error updating session card', res.session_id, res.error );
		}
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = online_events;